import pick from "lodash/pick";

import {
  type CleanLocationDraftForServer,
  IndividualScreenerLocationStatus,
  type IndividualScreenerLocationStatusType,
  type ScreenerLocation,
  type ScreenerLocationDraft,
} from "@/types/screener-location";
import { trimToNull } from "@/utils/string";
import { formatValidatedDraftWagesForServer } from "@/utils/wage";

export const locationIsLive = (
  locationOrStatus:
    | IndividualScreenerLocationStatusType
    | { status: IndividualScreenerLocationStatusType },
) =>
  (typeof locationOrStatus === "string"
    ? locationOrStatus
    : locationOrStatus?.status) === IndividualScreenerLocationStatus.Live;

export const locationHasCompletedSessions = (location?: ScreenerLocation) =>
  (location?.sessionCount ?? 0) > 0;

export const formatLocationDraftForServer = (
  location: ScreenerLocationDraft,
): CleanLocationDraftForServer => {
  const propertiesForServerDraft = [
    "atsJobId",
    "locationName",
    "maxPayHourly",
    "minPayHourly",
    "shareLinkSlug",
    "status",
  ] as const;
  const cleaned = pick<
    ScreenerLocationDraft,
    (typeof propertiesForServerDraft)[number]
  >(location, propertiesForServerDraft);

  return {
    ...cleaned,
    ...formatValidatedDraftWagesForServer(location),
    atsJobId: trimToNull(cleaned.atsJobId),
    locationName: cleaned.locationName.trim(),
    shareLinkSlug: trimToNull(cleaned.shareLinkSlug),
  };
};
